export default __webpack_public_path__ + "static/newsletter_confirmation-8cb8fc0897ae7e0d7b1d73413d37e650.png";